export const initialiseFilterSalarySlider = (widget: HTMLElement) => {
    const filter = widget.querySelector<HTMLDivElement>('.salary-slider')
    if (!filter) return

    const header = filter.querySelector<HTMLHeadingElement>('.header')
    if (!header) return

    const button: HTMLButtonElement = document.createElement('button')
    button.className = header.className
    button.innerHTML = header.innerHTML

    header.replaceWith(button)

    const optionsContainer = filter.querySelector<HTMLDivElement>('.option-display-list')
    const buttonsContainer = filter.querySelector<HTMLDivElement>('.job-filter-buttons-container')
    const sliderContainer = filter.querySelector<HTMLDivElement>('.salary-slider__container')
    if (!optionsContainer || !buttonsContainer || !sliderContainer) return

    const buttons = buttonsContainer.cloneNode(true) as HTMLDivElement
    sliderContainer.append(buttons)
    buttonsContainer.remove()
    optionsContainer.remove()
}